import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ContactUs } from '../models/contact-us.model';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  private contactFormUrl = 'v1/services/contacts';

  constructor(private httpClient: HttpClient) {

  }

  sendContactForm(contact: ContactUs): Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });

    //return this.httpClient.post<ContactUs>(`${environment.apiUrl}${this.contactFormUrl}`, contact, { headers: headers });
    return this.httpClient.post<ContactUs>(`${environment.apiPlaces}${this.contactFormUrl}`, contact, { headers: headers });
  }

}
